import { MegaMenuItem } from './mega-menu-item';

export const CIMB_PULSE: MegaMenuItem[] = [
  {
    label: 'CIMB In The News',
    url: '/en/personal/cimb-pulse/cimb-in-the-news.html',
  },
  {
    label: 'Savings Strategies',
    url: '/en/personal/cimb-pulse/savings-strategies.html',
  },
  {
    label: 'Investing My Money',
    url: '/en/personal/cimb-pulse/investing-my-money.html',
  },
  {
    label: 'Travel Tips',
    url: '/en/personal/cimb-pulse/travel-tips.html',
  },
  {
    label: 'Planning For My Future',
    url: '/en/personal/cimb-pulse/planning-for-my-future.html',
  },
  {
    label: 'Thinking About Insurance',
    url: '/en/personal/cimb-pulse/thinking-about-insurance.html',
  },
  {
    label: 'CIMB Vlog',
    children: [
      {
        label: 'CIMB Coffee Conversation',
        url: '/en/personal/cimb-pulse/cimb-vlog/cimb-coffee-conversation.html',
      },
    ],
  },
  {
    label: 'CIMB Compilation',
    url: '/en/personal/cimb-pulse/cimb-compilation.html',
  },
];

export const BANKING_WITH_US: MegaMenuItem[] = [
  {
    label: 'CIMB Preferred',
    url: '/en/personal/banking-with-us/cimb-preferred.html',
  },
  {
    label: 'CIMB F.I.R.S.T',
    url: '/en/personal/banking-with-us/cimb-first.html',
  },
  {
    label: 'Accounts',
    children: [
      {
        label: 'Savings Accounts',
        url: '/en/personal/banking-with-us/accounts/savings-accounts.html',
      },
      {
        label: 'Current Accounts',
        url: '/en/personal/banking-with-us/accounts/current-accounts.html',
      },
      {
        label: 'Fixed Deposit',
        url: '/en/personal/banking-with-us/accounts/fixed-deposit.html',
      },
    ],
  },
  {
    label: 'Cards',
    children: [
      {
        label: 'Credit Cards',
        url: '/en/personal/banking-with-us/cards/credit-cards.html',
      },
      {
        label: 'Other Credit Card Services',
        url: '/en/personal/banking-with-us/cards/other-credit-card-services.html',
      },
    ],
  },
  {
    label: 'Loans & Financing',
    children: [
      {
        label: 'Personal Loans & Financing',
        url: '/en/personal/banking-with-us/loans-financing/personal-loans-financing.html',
      },
      {
        label: 'Property Loan',
        url: '/en/personal/banking-with-us/loans-financing/property-loan.html',
      },
    ],
  },
  {
    label: 'Investments',
    url: '/en/personal/banking-with-us/investments.html',
  },
  {
    label: 'Insurance',
    children: [
      {
        label: 'General Insurance',
        url: '/en/personal/banking-with-us/insurance/general-insurance.html',
      },
      {
        label: 'Life Insurance',
        url: '/en/personal/banking-with-us/insurance/life-insurance.html',
      },
    ],
  },
  {
    label: 'Other Services',
    children: [
      {
        label: 'Remittance',
        url: '/en/personal/banking-with-us/other-services/remittance.html',
      },
    ],
  },
];

export const DIGITAL_SERVICES: MegaMenuItem[] = [
  {
    label: 'CIMB Clicks',
    children: [
      {
        label: 'Clicks for Cards',
        url: '/en/personal/digital-services/cimb-clicks/clicks-for-cards.html',
      },
      {
        label: 'CIMB Clicks Mobile Banking',
        url: '/en/personal/digital-services/cimb-clicks/cimb-clicks-mobile-banking.html',
      },
      {
        label: 'CIMB Clicks Online Banking',
        url: '/en/personal/digital-services/cimb-clicks/cimb-clicks-online-banking.html',
      },
      {
        label: 'CIMB Clicks Digital Token',
        url: '/en/personal/digital-services/cimb-clicks/cimb-clicks-digital-token.html',
      },
    ],
  },
  {
    label: 'Payment & Transfers',
    children: [
      {
        label: 'Cross-border Transfers',
        url: '/en/personal/digital-services/payment-transfers/cross-border-transfers.html',
      },
      {
        label: 'CIMB SLIDE Services',
        url: '/en/personal/digital-services/payment-transfers/slide.html',
      },
      {
        label: 'Mobile Payment',
        url: '/en/personal/digital-services/payment-transfers/mobile-payment.html',
      },
    ],
  },
  {
    label: 'Online Applications',
    url: '/en/personal/digital-services/online-applications.html',
  },
  {
    label: 'Consult-OnTheGo',
    url: '/en/personal/digital-services/consult-onthego.html',
  },
];

export const PROMOTIONS: MegaMenuItem[] = [
  {
    label: 'Latest Promotions',
    url: '/en/personal/promotions/latest-promotions.html',
  },
  {
    label: 'CIMB Card Deals',
    url: '/en/personal/promotions/cimb-deals.html',
  },
  {
    label: 'Events',
    url: '/en/personal/promotions/events.html',
  },
];

export const HELP_AND_SUPPORT: MegaMenuItem[] = [
  {
    label: 'Rates & Charges',
    url: '/en/personal/help-support/rates-charges.html',
  },
  {
    label: 'Download Center',
    children: [
      {
        label: 'Printable Forms',
        url: '/en/personal/help-support/download-center/printable-forms.html',
      },
    ],
  },
  {
    label: 'Contact Us',
    url: '/en/personal/help-support/contact-us.html',
  },
  {
    label: 'Branch Locator',
    url: '/en/personal/help-support/branch-locator.html',
  },
  {
    label: 'General Terms and Conditions',
    url: '/en/personal/help-support/general-terms-and-conditions.html',
  },
  {
    label: 'FAQ',
    url: '/en/personal/help-support/faq.html',
  },
  {
    label: 'Ways to Bank',
    children: [
      {
        label: 'Self-Service Banking',
        url: '/en/personal/help-support/ways-to-bank/self-service-banking.html',
      },
      {
        label: 'Online Banking',
        url: '/en/personal/help-support/ways-to-bank/online-banking.html',
      },
      {
        label: 'Mobile Banking',
        url: '/en/personal/help-support/ways-to-bank/mobile-banking.html',
      },
      {
        label: 'Branch',
        url: '/en/personal/help-support/ways-to-bank/branch.html',
      },
    ],
  },
  {
    label: 'Regulations & Policies',
    url: '/en/personal/help-support/regulations-policies.html',
  },
  {
    label: 'Security & Fraud',
    url: '/en/personal/help-support/security-fraud.html',
  },
];

export const QUICK_LINK: MegaMenuItem[] = [
  {
    label: 'Tools',
    url: '/en/personal/tools.html',
  },
  {
    label: 'Important Notices',
    url: '/en/personal/important-notices.html',
  },
];
